import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const formatDate = (date) => {
  if (!Array.isArray(date)) return "Unknown date";
  const [year, month, day] = date;
  return `${day.toString().padStart(2, "0")}-${month.toString().padStart(2, "0")}-${year}`;
};

const BlogCard = ({ title, description, imageUrl, blogId, author, date, tags, slug }) => {
  const excerpt = description ? description.slice(0, 100) : "No description available.";
  const tagList = tags ? tags.split(",").map((t) => t.trim()).filter(Boolean) : [];

  return (
    <div className="blog-card">
      <div className="blog-card__img-wrap">
        <img src={imageUrl} alt={title} className="blog-card__img" />
      </div>
      <div className="blog-card__body">
        {tagList.length > 0 && (
          <div className="blog-card__tags">
            {tagList.slice(0, 3).map((tag) => (
              <span key={tag} className="blog-card__tag">#{tag}</span>
            ))}
          </div>
        )}
        <h3 className="blog-card__title">{title}</h3>
        <p className="blog-card__meta">
          By {author || "Unknown"} · {formatDate(date)}
        </p>
        <p className="blog-card__excerpt">{excerpt}…</p>
        <Link to={`${blogId}/${slug}`} className="blog-card__read-more">
          Read more <ArrowRight size={13} strokeWidth={2.5} />
        </Link>
      </div>
    </div>
  );
};

export default BlogCard;